import { connect } from "react-redux";
import { isEmpty } from "lodash";
import {
  DropoffLocationSelection as Component,
  DropoffLocationSelectionProps,
} from "./DropoffLocationSelection.component";
import { RootState } from "../../reducers";
import {
  getAppId,
  getCurrentGeoCoordinates,
  getDestination,
  getNearbyDestinationError,
  getNearbyDestinations,
} from "../../selector";
import { getLocationRouterView } from "../LocationRouter/selectors";
import { requestGoogleNearbySearch } from "../../action";
import { getCustomDestination } from "./selectors";

const mapStateToProps = (state: RootState) => {
  const isDropoffLocationFocused = !isEmpty(getDestination(state)) || !isEmpty(getCustomDestination(state));
  return {
    appId: getAppId(state),
    currentGeoCoordinates: getCurrentGeoCoordinates(state),
    isDropoffLocationFocused,
    loading: getNearbyDestinations(state).destinations.length === 0 && !getNearbyDestinationError(state),
    view: getLocationRouterView(state),
  } as Pick<
    DropoffLocationSelectionProps,
    "appId" | "currentGeoCoordinates" | "isDropoffLocationFocused" | "loading" | "view"
  >;
};

export const DropoffLocationSelection = connect(mapStateToProps, {
  onInit: requestGoogleNearbySearch,
} as Pick<DropoffLocationSelectionProps, "onInit">)(Component);
